// extracted by mini-css-extract-plugin
export default {"nav-link":"navbar_nav-link__PuZsD","nav-link--disabled":"navbar_nav-link--disabled__lp65j"};